import { useEffect } from 'react'

export const useHideBecka = (hidden: boolean) => {
  useEffect(() => {
    if (!hidden) return
    document.body.dataset.chatWidget = 'true'
    return () => {
      delete document.body.dataset.chatWidget
    }
  }, [hidden])
}
